"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var selectors_1 = require("services/auth/selectors");
var actions_1 = require("services/event-tracking/actions");
var event_tracking_1 = require("services/event-tracking");
var queries_generated_1 = require("./queries.generated");
/**
 * Hook for managing thumbs up/down state and mutations.
 * Handles:
 * - Optimistic UI updates with automatic rollback on error
 * - GraphQL mutation
 * - GA4 analytics tracking
 * - Toggle behavior (clicking same thumb clears it)
 */
var useThumbsUpdate = function (options) {
    var auth = (0, react_redux_1.useSelector)(selectors_1.selectAuth);
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, queries_generated_1.useUpdateMessagePairThumbsMutation)(), updateMutation = _a[0], isUpdating = _a[1].loading;
    var _b = (0, react_1.useState)({}), thumbsValues = _b[0], setThumbsValues = _b[1];
    var updateThumb = (0, react_1.useCallback)(function (messagePairId_1, newValue_1) {
        var args_1 = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args_1[_i - 2] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([messagePairId_1, newValue_1], args_1, true), void 0, function (messagePairId, newValue, currentBackendValue) {
            var localValue, currentValue, valueToSend, error_1;
            if (currentBackendValue === void 0) { currentBackendValue = 'none'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localValue = thumbsValues[messagePairId];
                        currentValue = localValue !== undefined ? localValue : currentBackendValue;
                        // Early exit if clicking 'none' when already 'none'
                        if (currentValue === 'none' && newValue === 'none') {
                            return [2 /*return*/];
                        }
                        valueToSend = currentValue === newValue ? 'none' : newValue;
                        // Optimistic update
                        setThumbsValues(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[messagePairId] = valueToSend, _a)));
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, updateMutation({
                                variables: {
                                    id: messagePairId,
                                    input: { thumbsValue: valueToSend },
                                },
                                context: {
                                    jwt: auth.get('jwt'),
                                    useMaster: true,
                                },
                            })
                            // GA4 analytics: track when setting a value (not when clearing)
                        ];
                    case 2:
                        _a.sent();
                        // GA4 analytics: track when setting a value (not when clearing)
                        if (valueToSend !== 'none') {
                            dispatch((0, actions_1.setAiGa4Event)(event_tracking_1.AI_RESPONSE_FEEDBACK_GA4_EVENT.mergeDeep({
                                content_rating: valueToSend,
                            })));
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        // Rollback to previous value on failure
                        setThumbsValues(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[messagePairId] = currentValue, _a)));
                        });
                        if (options === null || options === void 0 ? void 0 : options.onError) {
                            options.onError(error_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [thumbsValues, updateMutation, auth, dispatch, options]);
    var getThumbValue = (0, react_1.useCallback)(function (messagePairId, backendValue) {
        if (backendValue === void 0) { backendValue = 'none'; }
        var localValue = thumbsValues[messagePairId];
        return localValue !== undefined ? localValue : backendValue;
    }, [thumbsValues]);
    return {
        updateThumb: updateThumb,
        getThumbValue: getThumbValue,
        thumbsValues: thumbsValues,
        isUpdating: isUpdating,
    };
};
exports.default = useThumbsUpdate;
